module.exports = __webpack_public_path__ + "static/img/微信图片_20220709152326.f55ca378.png";